import { useAppSelector } from "~/app/hooks"
import { isDarkTheme } from "~/redux/features"
import { Box } from '@mui/material'

interface IAssetMappingIcon {
  deviceFormationId: number
  size?: number
}
export function MapDeviceFormationId(param: number): string {
  switch (param) {
    case 500:
      return 'Wearable'
    case 600:
      return 'Phone' //PTTOX
    case 401:
      return 'Gridlink'
    case 301:
    case 303:
    case 317:
    case 319:
    case 700: //TMX500
      return 'UVe'
    case 201:
    case 203:
    case 205:
    case 207:
    case 217:
    case 219:
    case 221:
      return 'DualTorso'
    case 101:
    case 103:
    case 105:
    case 107:
    case 117:
    case 119:
    case 121:
      return 'Mobile'
    case 109:
    case 110:
      return 'Harris'
    case 0:
      return 'Unknown'
    default:
      return 'Portable'
  }
}

export function AssetMappingIcon({ deviceFormationId, size }: IAssetMappingIcon) {
  const isDarkMode = useAppSelector(isDarkTheme);
  const mapped = MapDeviceFormationId(deviceFormationId);
  
  let imgPath = mapped
  if (mapped === 'Harris') {
    imgPath =  isDarkMode ? `${imgPath}-dark` : `${imgPath}-light`;
  }

  if (deviceFormationId === 0) return null
  return (
    <Box
      component='img'
      title={MapDeviceFormationId(deviceFormationId)}
      src={`/images/${imgPath}.svg`}
      alt={MapDeviceFormationId(deviceFormationId)}
      height={size ?? 40}
      sx={{ maxHeight: '40px', maxWidth: '60px' }}
    />
  )
}
